<template>
  <div v-show="foundCountry">
    <GmapMap
      :center="{ lat: 0, lng: 0 }"
      ref="mapRef"
      :zoom="3"
      :options="mapOptions"
      map-type-id="terrain"
      style="width: 100%; height: 140px; margin: auto; position: relative;"
    >
    </GmapMap>
  </div>
</template>

<script>
export default {
  name: "CountryMap",
  props: ["provider"],
  data() {
    return {
      foundCountry: false,
      mapOptions: {
        disableDefaultUI: true,
        styles: [
          { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
          { elementType: "labels.text.fill", stylers: [{ color: "#523735" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#f5f1e6" }]
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [{ color: "#c9b2a6" }]
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "geometry.stroke",
            stylers: [{ color: "#dcd2be" }]
          },
          {
            featureType: "landscape.natural",
            elementType: "geometry",
            stylers: [{ color: "#55c74e" }]
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{ color: "#dfd2ae" }]
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{ color: "#55c74e" }]
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#f5f1e6" }]
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{ color: "#806b63" }]
          },
          {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [{ color: "#bee1e1" }]
          },
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "administrative.province",
            elementType: "labels",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "water",
            elementType: "labels",
            stylers: [{ visibility: "off" }]
          }
        ]
      }
    };
  },
  watch: {
    provider: {
      handler: function(val) {
        this.searchLocation();
      },
      deep: true
    }
  },
  mounted() {
    this.searchLocation();
  },
  methods: {
    searchLocation: function() {
      if (this.provider == undefined) return;
      if (google.maps == undefined) return;
      var geocoder = new google.maps.Geocoder();
      var target = { address: this.provider.offices[0].country.name };
      geocoder.geocode(target, (results, status) => {
        this.$refs.mapRef.$mapPromise.then(map => {
          this.foundCountry = true;
          if (status == google.maps.GeocoderStatus.OK) {
            map.setCenter(results[0].geometry.location);
          }
        });
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/elements/charts/CountryMap.vue